import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    width: '100%',
  },
  floatLeft: {
    float: 'left',
    borderLeft: '1px solid #aaa',
    height: '100%',
  },
  coulomContent: {
    minWidth: 'calc(9vw - 0.2rem)',
  },
  header: {
    width: '100%',
    height: '72.5px',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    fontFamily: 'Poppins',
    fontSize: '15px',
    paddingLeft: '2vh',
    color: 'white',
    textTransform: 'uppercase',
  },
  headerTextCenter: {
    justifyContent: 'center',
    paddingLeft: '0',
  },
  content: {
    width: '100%',
    height: '45.5px',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    fontFamily: 'Poppins',
    fontSize: '15px',
    color: '#0E1247',
    paddingLeft: '2vh',
  },
  contentBtn: {
    width: '100%',
    height: '45.5px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: 'Poppins',
    fontSize: '15px',
    color: '#0E1247',
    '& .MuiButton-label': {
      textTransform: 'capitalize',
      color: '#23296F',
      marginTop: '2px !important',
    },
  },
  button: {
    padding: '12px 20px',
    border: '1.5px solid #CDCEDA',
    borderRadius: '4px',
    height: '32px',
  },
  link: {
    color: 'rgba(14, 18, 71, 1)',
    textDecoration: 'underline',
  },

  // Consultant (manager_1) only
  consultantContent: {
    height: '72px',
    paddingTop: '10px',
    paddingBottom: '10px',
    boxSizing: 'border-box',
  },
  consultantContentBtn: {
    height: '72px',
    boxSizing: 'border-box',
    '& .MuiButton-label': {
      textTransform: 'none',
      fontFamily: 'Poppins',
      fontWeight: 500,
    },
  },
  consultantButton: {
    padding: '8px 18px',
    borderRadius: '6px',
    height: '34px',
    minWidth: '110px',
    backgroundColor: '#FFFFFF',
  },
  userIdentity: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '2px',
    minWidth: 0,
  },
  userName: {
    border: 'none',
    background: 'transparent',
    padding: 0,
    margin: 0,
    cursor: 'pointer',
    fontFamily: 'Poppins',
    fontSize: '14px',
    fontWeight: 600,
    color: '#0E1247',
    textAlign: 'left',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  userEmail: {
    fontFamily: 'Poppins',
    fontSize: '12px',
    fontWeight: 400,
    color: '#8B90A5',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '100%',
  },
  badgesRow: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '6px',
    width: '100%',
  },
  serviceBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '5px',
    padding: '4px 10px',
    fontFamily: 'Poppins',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: 1.3,
    whiteSpace: 'nowrap',
  },
  moreBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '5px',
    padding: '4px 8px',
    fontFamily: 'Poppins',
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: 1.3,
    backgroundColor: '#FFFFFF',
    color: '#5A607F',
    border: '1px solid #CDCEDA',
  },
  statusBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '6px',
    padding: '4px 12px',
    fontFamily: 'Poppins',
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: 1.3,
  },
  statusActive: {
    backgroundColor: '#D8F0C8',
    color: '#3F6B1D',
  },
  statusInactive: {
    backgroundColor: '#E8EAF0',
    color: '#5A607F',
  },
  emptyValue: {
    color: '#8B90A5',
    fontSize: '13px',
  },
});
